import type {Rating, Rec} from 'typings/portaro.be.types';
import type RatingDataService from './rating.data-service';
import type FinishedResponseInteractionService from 'shared/services/finished-response-interaction.service';
import {isExceptionResponseOf} from '../../../modals/modal-utils';
import {exceptionTypes} from 'shared/constants/portaro.constants';

export class KpRatingPresenter {
    public static presenterName = 'kpRatingPresenter';

    /*@ngInject*/
    constructor(private ratingDataService: RatingDataService, private finishedResponseInteractionService: FinishedResponseInteractionService) {
    }

    public async loadRating(record: Rec): Promise<Rating | null> {
        try {
            return await this.ratingDataService.getById(record.id);
        } catch (exceptionResponse) {
            this.finishedResponseInteractionService.showFailedResponseInToast(exceptionResponse);
            return null;
        }
    }

    public async rate(record: Rec, value: number): Promise<Rating | null> {
        try {
            const response = await this.ratingDataService.createRating(record.id, value);
            return response.savedObject;
        } catch (exceptionResponse) {
            if (isExceptionResponseOf(exceptionResponse, exceptionTypes.ALREADY_EVALUATED_EXCEPTION)) {
                this.finishedResponseInteractionService.showFailedResponseInToast(exceptionResponse);
                return null;
            }
            await this.finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
            return null;
        }
    }
}